import { GET_RESIGNATIONS } from "./types";
import { ResignationsResponseType } from "@type/HRM/resignations";
import { PaginationRequestType } from "@type/HRM/pagination";

export const getResignationsRequest = (payload: PaginationRequestType) => {
  return {
    type: GET_RESIGNATIONS.GET_RESIGNATIONS_REQUEST,
    payload: { payload },
  } as const;
};

export const getResignationsSuccess = (data: ResignationsResponseType) => {
  return {
    type: GET_RESIGNATIONS.GET_RESIGNATIONS_SUCCESS,
    payload: { data },
  } as const;
};

export const getResignationsFailed = () => {
  return {
    type: GET_RESIGNATIONS.GET_RESIGNATIONS_FAILED,
  } as const;
};

export type ResignationsActions =
  | ReturnType<typeof getResignationsRequest>
  | ReturnType<typeof getResignationsSuccess>
  | ReturnType<typeof getResignationsFailed>;
